(function () {
  var EXCLUDE = ['what_sport_do_you_play', 'player_age', 'throwing_hand', 'leather_type_info', 'measure_information_element', 'flags', 'group-Leathers', 'web_style', 'wrist_logo_options', 'glove_type', 'add_a_finger_pad_or_finger_hood', 'finger_pad_location'];

  function sectionKey(section) {
    return section.id.replace('customizer-element-', '');
  }

  function isColorSection(section) {
    return EXCLUDE.indexOf(sectionKey(section)) === -1 && !!section.querySelector('img[data-name]');
  }

  function colorSections() {
    return [].slice.call(document.querySelectorAll('[id^="customizer-element-"]')).filter(isColorSection);
  }

  function labelFor(section) {
    var label = section.querySelector('.builder-swatch-label');
    if (!label) {
      label = document.createElement('div');
      label.className = 'builder-swatch-label';
      var container = section.querySelector('.customizer-element-value-container');
      if (container) container.parentNode.insertBefore(label, container);
    }
    return label;
  }

  function setupSection(section) {
    section.classList.add('builder-swatch-grid');
    var title = section.querySelector('.customizer-element-title');
    if (title && !title.dataset.collapsible) {
      title.dataset.collapsible = '1';
      title.classList.add('builder-collapse-toggle');
      title.addEventListener('click', function () {
        section.classList.toggle('builder-collapsed');
      });
    }
  }

  function updateSection(section) {
    var selected = section.querySelector('img.customizer-selected[data-name]');
    labelFor(section).textContent = selected ? selected.getAttribute('data-name') : '';
    [].slice.call(section.querySelectorAll('img[data-name]')).forEach(function (img) {
      if (img._chip) img._chip.classList.toggle('customizer-selected', img.classList.contains('customizer-selected'));
    });
  }

  function allColorNames() {
    var seen = {};
    var names = [];
    colorSections().forEach(function (section) {
      [].slice.call(section.querySelectorAll('img[data-name]')).forEach(function (img) {
        var name = img.getAttribute('data-name').trim();
        if (!seen[name]) {
          seen[name] = true;
          names.push({ name: name, src: img.getAttribute('src') });
        }
      });
    });
    return names;
  }

  function buildApplyAll() {
    var first = colorSections()[0];
    if (!first || document.querySelector('.builder-apply-all')) return;
    var bar = document.createElement('div');
    bar.className = 'builder-apply-all';
    var heading = document.createElement('div');
    heading.className = 'builder-apply-all-heading';
    heading.textContent = 'Apply one color to all sections';
    bar.appendChild(heading);
    var row = document.createElement('div');
    row.className = 'builder-apply-all-row';
    allColorNames().forEach(function (item) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'builder-apply-all-swatch';
      b.title = item.name;
      b.setAttribute('aria-label', item.name);
      var img = document.createElement('img');
      img.src = item.src;
      img.alt = item.name;
      b.appendChild(img);
      b.addEventListener('click', function () {
        colorSections().forEach(function (section) {
          [].slice.call(section.querySelectorAll('img[data-name]')).some(function (img) {
            if (img.getAttribute('data-name').trim() !== item.name) return false;
            img.click();
            return true;
          });
        });
      });
      row.appendChild(b);
    });
    bar.appendChild(row);
    first.parentNode.insertBefore(bar, first);
  }

  function stripCrossOrigin() {
    [].slice.call(document.querySelectorAll('#customizer-root img[crossorigin], #customizer-modal img[crossorigin], img[data-name][crossorigin]')).forEach(function (img) {
      img.removeAttribute('crossorigin');
      var src = img.getAttribute('src');
      img.setAttribute('src', src);
    });
  }

  function swapTitleForLogo() {
    var title = document.querySelector('.customizer-product-name');
    if (!title) return;
    var link = document.createElement('a');
    link.href = 'https://www.graceglovecompany.com/pages/builder';
    link.className = 'builder-logo-link';
    link.setAttribute('aria-label', 'Grace Glove Company home');
    var logo = document.createElement('img');
    logo.src = '/cdn/shop/files/Logo_-_No_Background_200x200.png';
    logo.alt = 'Grace Glove Company';
    logo.className = 'builder-logo';
    link.appendChild(logo);
    title.replaceWith(link);
  }

  function moveMeasureUnderAge() {
    var measure = document.getElementById('customizer-element-measure_information_element');
    var age = document.getElementById('customizer-element-player_age');
    if (!measure || !age) return;
    if (measure.previousElementSibling !== age) age.parentNode.insertBefore(measure, age.nextSibling);
  }

  function sizeTextFor(props) {
    var sport = document.querySelector('#customizer-element-what_sport_do_you_play img.customizer-selected');
    var age = document.querySelector('#customizer-element-player_age img.customizer-selected');
    var listId = 'size_baseball';
    if (age && /youth/i.test(age.getAttribute('data-name') || '')) listId = 'size_youth';
    else if (sport && /softball/i.test(sport.getAttribute('data-name') || '')) listId = 'size_softball';
    var select = chosenSizeListId ? document.getElementById(chosenSizeListId) : document.getElementById('list-element-select-' + listId);
    if (!select || select.selectedIndex < 0) return chosenSize;
    return select.options[select.selectedIndex].text;
  }

  function activeSizeSelect() {
    var selects = [].slice.call(document.querySelectorAll('select[id^="list-element-select-size"]'));
    return selects.filter(function (s) { return s.offsetParent !== null; })[0] || null;
  }

  var chosenSize = null;

  var chosenSizeListId = null;

  function rememberSize(select) {
    if (select && select.selectedIndex >= 0) {
      chosenSize = select.options[select.selectedIndex].text;
      chosenSizeListId = select.id;
    }
  }

  document.addEventListener('change', function (event) {
    if (event.target && event.target.id && event.target.id.indexOf('list-element-select-size') === 0) rememberSize(event.target);
  }, true);

  // VU summary rows with no label (the redundant size value) are hidden. Labeled rows are kept.
  function hideUnlabeledSummaryRows() {
    [].slice.call(document.querySelectorAll('.customizer-summary-item, .customizer-tab-summary-item')).forEach(function (row) {
      var name = row.querySelector('[class$="element-name"]');
      if (!name || !name.textContent.trim()) row.style.display = 'none';
    });
  }

  // VU's size rows keep their own list's value (for example youth 11.00"), so copy the chosen size into them.
  // Only the text changes; the rows stay visible and VU's data is untouched.
  function syncSummarySizeText() {
    if (!chosenSize) return;
    [].slice.call(document.querySelectorAll('[id^="customizer-summary-item-size_"] [class$="-item-name"]')).forEach(function (el) {
      if (el.textContent !== chosenSize) el.textContent = chosenSize;
    });
  }

  // Debug box for size problems. Only shows when the link has &debug=1.
  function showSizeDebug() {
    if (!new URLSearchParams(window.location.search).get('debug')) return;
    var box = document.getElementById('size-debug');
    if (!box) {
      box = document.createElement('div');
      box.id = 'size-debug';
      box.style.cssText = 'position:fixed;left:0;right:0;bottom:0;z-index:99999;background:#fff;color:#000;font:12px monospace;padding:6px;border-top:2px solid red;';
      document.body.appendChild(box);
    }
    var lists = ['baseball', 'softball', 'youth'].map(function (id) {
      var s = document.getElementById('list-element-select-size_' + id);
      return id + ':' + (s && s.options[s.selectedIndex] ? s.options[s.selectedIndex].text : 'none');
    });
    var pills = [].slice.call(document.querySelectorAll('.builder-size-pill.is-selected')).map(function (p) { return p.textContent; });
    box.textContent = 'chosenList=' + chosenSizeListId + ' chosenSize=' + chosenSize + ' | ' + lists.join(' | ') + ' | pills=' + pills.join(',');
  }

  function applyVariant() {
    var variant = new URLSearchParams(window.location.search).get('variant');
    if (!variant || document.body.classList.contains('builder-variant-' + variant)) return;
    document.body.classList.add('builder-variant-' + variant);
    if (variant === 'team' && !document.getElementById('builder-team-qty')) {
      var box = document.createElement('div');
      box.id = 'builder-team-qty';
      box.innerHTML = '<label>Quantity<input type="number" min="1" value="1"></label><p>Sample only, not connected to the cart yet.</p>';
      var panel = document.getElementById('customizer-tab-body-container');
      if (panel) panel.appendChild(box);
    }
  }

  var GLOVE_CODES = { catchers: 'CAT', fielders: 'FLD', firstBase: 'FB' };
  var LEATHER_CODES = { steerhide_leather: 'ST', kip_leather: 'KK', japanese_leather: 'JK' };
  var variantCache = {};

  function skuFor(props) {
    var glove = GLOVE_CODES[new URLSearchParams(window.location.search).get('product')];
    var leather = LEATHER_CODES[props.leather_type];
    var flag = props.add_flag === 'yes' ? 'Y' : 'N';
    if (!glove || !leather) return null;
    return 'CUST-' + glove + '-' + leather + '-' + flag;
  }

  function variantIdFor(sku) {
    var handle = sku.toLowerCase();
    if (variantCache[handle]) return Promise.resolve(variantCache[handle]);
    return window.fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (product) {
      variantCache[handle] = product.variants[0].id;
      return variantCache[handle];
    });
  }

  function cleanCartItem(item, sku) {
    var props = item.properties;
    delete props.measure_information_element;
    Object.keys(props).forEach(function (key) {
      if (/^size/i.test(key) && key !== 'Size') delete props[key];
    });
    var sizeText = sizeTextFor(props);
    if (sizeText) props.Size = sizeText;
    // Also write the size under VU's own property name (size_baseball, size_softball or
    // size_youth), the way VU did before. The traveler reads those names.
    var sizeSelect = chosenSizeListId && document.getElementById(chosenSizeListId);
    if (sizeSelect && sizeSelect.value) props[chosenSizeListId.replace('list-element-select-', '')] = sizeSelect.value;
    return sku;
  }

  // The add-to-cart call goes through XMLHttpRequest, not fetch, so this
  // rewrite must be synchronous. It only works once the variant IDs are cached.
  function rewriteCartBodySync(url, rawBody) {
    if (!/\/cart\/add\.js/.test(url) || typeof rawBody !== 'string') return null;
    var body;
    try { body = JSON.parse(rawBody); } catch (e) { return null; }
    var item = body.items && body.items[0];
    if (!item || !item.properties) return null;
    var sku = skuFor(item.properties);
    if (!sku || !variantCache[sku.toLowerCase()]) return null;
    if (body.items.length > 1) body.items = [item];
    cleanCartItem(item, sku);
    item.id = variantCache[sku.toLowerCase()];
    console.info('[builder] cart add rewritten to', sku);
    return JSON.stringify(body);
  }

  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (!/\/cart\/add\.js/.test(url) || !init || typeof init.body !== 'string') return nativeFetch.apply(this, arguments);
    var body;
    try { body = JSON.parse(init.body); } catch (e) { return nativeFetch.apply(this, arguments); }
    var item = body.items && body.items[0];
    if (body.items && body.items.length > 1) body.items = [item];
    var sku = item && item.properties && skuFor(item.properties);
    if (!sku) return nativeFetch.apply(this, arguments);
    cleanCartItem(item, sku);

    return variantIdFor(sku).then(function (variantId) {
      item.id = variantId;
      return nativeFetch.call(window, url, Object.assign({}, init, { body: JSON.stringify(body) }));
    }, function () {
      return nativeFetch.apply(window, arguments);
    });
  };

  var nativeOpen = XMLHttpRequest.prototype.open;
  var nativeSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._builderUrl = String(url);
    return nativeOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (data) {
    var rewritten = rewriteCartBodySync(this._builderUrl || '', data);
    return nativeSend.call(this, rewritten !== null ? rewritten : data);
  };

  // Warm the variant cache for every SKU this product can produce, so the
  // synchronous XHR rewrite above has IDs ready before the customer clicks add.
  var warmGlove = GLOVE_CODES[new URLSearchParams(window.location.search).get('product')];
  if (warmGlove) {
    Object.keys(LEATHER_CODES).forEach(function (leather) {
      ['Y', 'N'].forEach(function (flag) {
        variantIdFor('CUST-' + warmGlove + '-' + LEATHER_CODES[leather] + '-' + flag).catch(function () {});
      });
    });
  }

  function hideRedundantHeadings() {
    [].slice.call(document.querySelectorAll('#customizer-root div, #customizer-modal div')).forEach(function (el) {
      if (el.children.length === 0 && el.textContent.trim() === 'Leathers') el.classList.add('builder-hidden-heading');
    });
  }

  function removeStaleLabels() {
    [].slice.call(document.querySelectorAll('[id^="customizer-element-"] > .builder-swatch-label')).forEach(function (label) {
      var section = label.parentElement;
      if (!isColorSection(section)) label.remove();
    });
  }

  var LEATHER_PRICES = { steerhide_leather: '$199', kip_leather: '$236', japanese_leather: '$306' };

  function addLeatherPrices() {
    [].slice.call(document.querySelectorAll('#list-element-radio-leather_type .customizer-list-element-radio-item')).forEach(function (item) {
      if (item.querySelector('.builder-leather-price')) return;
      var price = LEATHER_PRICES[item.getAttribute('data-code')];
      if (!price) return;
      var label = item.querySelector('label');
      if (!label) return;
      var span = document.createElement('span');
      span.className = 'builder-leather-price';
      span.textContent = price;
      label.appendChild(span);
    });
  }

  function openMeasureModal(measure) {
    var existing = document.getElementById('builder-measure-modal');
    if (existing) existing.remove();
    var modal = document.createElement('div');
    modal.id = 'builder-measure-modal';
    var content = measure.querySelector('.customizer-element-value-container');
    modal.innerHTML = '<div class="builder-measure-box"><button type="button" class="builder-measure-close" aria-label="Close">&times;</button>' + (content ? content.innerHTML : '') + '</div>';
    modal.addEventListener('click', function (event) {
      if (event.target === modal || event.target.classList.contains('builder-measure-close')) modal.remove();
    });
    document.body.appendChild(modal);
  }

  function addMeasureInfo() {
    var age = document.getElementById('customizer-element-player_age');
    var measure = document.getElementById('customizer-element-measure_information_element');
    if (!age || !measure || age.querySelector('.builder-info-button')) return;
    var title = age.querySelector('.customizer-element-title');
    if (!title) return;
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'builder-info-button';
    button.setAttribute('aria-label', 'How to measure');
    button.textContent = 'i';
    button.addEventListener('click', function (event) {
      event.stopPropagation();
      openMeasureModal(measure);
    });
    title.appendChild(button);
  }

  function updateSpecSize() {
    var text = sizeTextFor({}) || '';
    var ages = document.querySelectorAll('[id="customizer-summary-item-player_age"]');
    [].slice.call(ages).forEach(function (age) {
      var row = age.nextElementSibling && age.nextElementSibling.classList.contains('builder-spec-size') ? age.nextElementSibling : null;
      if (!row) {
        row = document.createElement('div');
        row.className = 'customizer-tab-summary-item builder-spec-size';
        row.innerHTML = '<div class="customizer-tab-summary-item-swatch"></div><div class="customizer-tab-summary-item-element-name">Size</div><div class="customizer-tab-summary-item-name"></div><div class="customizer-tab-summary-item-quantity"></div><div class="customizer-tab-summary-item-upcharge"></div>';
        age.parentNode.insertBefore(row, age.nextSibling);
      }
      row.querySelector('.customizer-tab-summary-item-name').textContent = text;
    });
  }

  document.addEventListener('change', function (event) {
    if (event.target && event.target.id && event.target.id.indexOf('list-element-select-size') === 0) updateSpecSize();
  }, true);

  function moveSizeAboveThrowingHand() {
    var hand = document.getElementById('customizer-element-throwing_hand');
    if (!hand) return;
    ['size_baseball', 'size_softball', 'size_youth'].forEach(function (id) {
      var size = document.getElementById('customizer-element-' + id);
      if (!size || size.parentNode !== hand.parentNode || size.dataset.placed === '1') return;
      hand.parentNode.insertBefore(size, hand);
      size.dataset.placed = '1';
    });
  }

  function syncSizePills(box, select) {
    [].slice.call(box.children).forEach(function (button) {
      button.classList.toggle('is-selected', select.value === button.dataset.value);
    });
  }

  function buildSizePills() {
    ['size_baseball', 'size_softball', 'size_youth'].forEach(function (id) {
      var section = document.getElementById('customizer-element-' + id);
      var select = section && section.querySelector('select');
      if (!select) return;
      var box = section.querySelector('.builder-size-pills');
      if (!box) {
        box = document.createElement('div');
        box.className = 'builder-size-pills';
        select.parentNode.insertBefore(box, select.nextSibling);
        [].slice.call(select.options).forEach(function (option, index) {
          var button = document.createElement('button');
          button.type = 'button';
          button.className = 'builder-size-pill';
          button.textContent = option.text;
          button.dataset.value = option.value;
          button.addEventListener('click', function () {
            // Match by value, not position: the pill's position can differ from the dropdown's on phones.
            var match = [].slice.call(select.options).findIndex(function (o) { return o.value === option.value; });
            if (match >= 0) select.selectedIndex = match;
            // VU saves the recipe on input, so the pill must fire it as well as change.
            select.dispatchEvent(new Event('input', { bubbles: true }));
            select.dispatchEvent(new Event('change', { bubbles: true }));
            rememberSize(select);
            updateSpecSize();
            syncSizePills(box, select);
          });
          box.appendChild(button);
        });
      }
      syncSizePills(box, select);
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest && event.target.closest('#customizer-tab-next, #customizer-tab-prev');
    if (!button) return;
    setTimeout(function () {
      var top = document.getElementById('customizer-tab-counter') || document.getElementById('customizer-tab-container');
      if (top && top.scrollIntoView) top.scrollIntoView({ block: 'start' });
      var body = document.getElementById('customizer-tab-body-container');
      if (body) body.scrollTop = 0;
    }, 150);
  }, true);

  function addLeatherInfo() {
    var leather = document.getElementById('customizer-element-leather_type');
    var info = document.getElementById('customizer-element-leather_type_info');
    if (!leather || !info || leather.querySelector('.builder-leather-info-button')) return;
    var title = leather.querySelector('.customizer-element-title');
    if (!title) return;
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'builder-info-button builder-leather-info-button';
    button.setAttribute('aria-label', 'Leather details');
    button.textContent = 'i';
    button.addEventListener('click', function (event) {
      event.stopPropagation();
      openMeasureModal(info);
    });
    title.appendChild(button);
  }

  function autoSelectRadioSizes() {
    ['adult_sizes', 'youth_sizes'].forEach(function (id) {
      var list = document.getElementById('list-element-radio-' + id);
      if (!list || list.dataset.autoSelected) return;
      var inputs = list.querySelectorAll('input[type=radio]');
      if (!inputs.length || [].slice.call(inputs).some(function (i) { return i.checked; })) return;
      list.dataset.autoSelected = '1';
      inputs[0].click();
    });
  }

  function eagerFlags() {
    [].slice.call(document.querySelectorAll('#customizer-element-flags img')).forEach(function (img) {
      if (img.getAttribute('loading') !== 'eager') img.setAttribute('loading', 'eager');
    });
  }

  function updateWebLabel() {
    var section = document.getElementById('customizer-element-web_style');
    if (!section) return;
    var container = section.querySelector('.customizer-element-value-container');
    if (!container) return;
    var label = section.querySelector('.builder-web-label');
    if (!label) {
      label = document.createElement('div');
      label.className = 'builder-web-label';
      container.parentNode.insertBefore(label, container);
    }
    var selected = section.querySelector('img.customizer-selected');
    label.textContent = selected ? (selected.getAttribute('data-name') || selected.alt || '') : '';
  }

  document.addEventListener('click', function (event) {
    if (event.target && event.target.closest && event.target.closest('#customizer-element-web_style img')) {
      setTimeout(updateWebLabel, 60);
    }
  }, true);

  function updateAll() {
    stripCrossOrigin();
    updateWebLabel();
    eagerFlags();
    autoSelectRadioSizes();
    addLeatherInfo();
    buildSizePills();
    moveSizeAboveThrowingHand();
    updateSpecSize();
    addMeasureInfo();
    addLeatherPrices();
    rememberSize(activeSizeSelect());
    removeStaleLabels();
    hideRedundantHeadings();
    applyVariant();
    hideUnlabeledSummaryRows();
    showSizeDebug();
    swapTitleForLogo();
    moveMeasureUnderAge();
    colorSections().forEach(function (section) {
      setupSection(section);
      updateSection(section);
    });
    buildApplyAll();
  }

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest && event.target.closest('img.customizer-list-element-images-item[data-name]');
    if (!swatch) return;
    var section = swatch.closest('[id^="customizer-element-"]');
    setTimeout(function () { if (section) updateSection(section); }, 50);
  });

  document.addEventListener('error', function (event) {
    var img = event.target;
    if (!img || img.tagName !== 'IMG' || !img.hasAttribute('data-name')) return;
    var name = img.getAttribute('data-name').trim();
    if (img.closest('.builder-apply-all-swatch')) {
      var button = img.closest('.builder-apply-all-swatch');
      button.textContent = name;
      button.classList.add('builder-swatch-fallback');
      return;
    }
    if (img._chip) return;
    img.classList.add('builder-img-failed');
    var chip = document.createElement('span');
    chip.className = 'builder-swatch-fallback';
    chip.textContent = name;
    chip.addEventListener('click', function () { img.click(); });
    img.parentNode.insertBefore(chip, img.nextSibling);
    img._chip = chip;
  }, true);

  document.addEventListener('load', function (event) {
    var img = event.target;
    if (!img || img.tagName !== 'IMG' || !img._chip) return;
    img.classList.remove('builder-img-failed');
    img._chip.remove();
    img._chip = null;
  }, true);

  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; updateAll(); }, 150);
  }).observe(document.body, { childList: true, subtree: true });

  updateAll();
})();
